import React, { useContext } from 'react';
import Warning from '../components/Warning';
import ButtonwithEnter from '../components/ButtonwithEnter';
import Title from '../components/Title';
import { ReactComponent as Eye } from '../assets/eye.svg';
import { ReactComponent as Eyeoff } from '../assets/eye-off.svg';
import encryptPasswordWithKey from '../encryptPasswordWithKey';
import PageIndicator from '../components/PageIndicator';
import PasswordValidattor from 'react-password-validattor';
import { context } from '../App';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';

export default function Professional({ readyToSubmit, isValidContactId, setIsValidContactId, setIsAgreementContactId, isAgreementContactId, contactId }) {
  const {
    payload,
    setPayload,
    passwordEye,
    confirmPasswordEye,
    inputChangeHandler,
    setSubmitClicked,
    token,
    referred,
    redeemId,
    slideCount,
    setSlideCount,
    urlToRedirect,
    setUrlToRedirect,
    submittedContactId,
    setSubmittedContactId,
    referredImg,
    right_container,
    windowWidth,
    showAgreement,
    submitClicked,
    categories,
    states,
    professions,
    countys,
    formatPhoneNumber,
    passwordEyeHandler,
    confirmPasswordEyeHandler,
    validateInput
  } = useContext(context);

  // const [searchParams] = useSearchParams()
  // const contactIdParam = searchParams.get('contactId');

  const showProfileQuestions = window.location.href.includes("pay.proinsight.com") || window.location.href.includes("get.proinsight.com");

  function getProfileAnswers() {
    return {
      "to_which_profession_send_most_referrals": payload.to_which_profession_send_most_referrals.to_which_profession_send_most_referrals,
      "from_which_profession_receive_most_referrals": payload.from_which_profession_receive_most_referrals.from_which_profession_receive_most_referrals,
      "website_url": payload.website_url.website_url,
      "instagram_handle": payload.instagram_handle.instagram_handle,
      "facebook_link": payload.facebook_link.facebook_link,
      "linkedin_handle": payload.linkedin_handle.linkedin_handle,
      "tiktok_handle": payload.tiktok_handle.tiktok_handle,
      "youtube_link": payload.youtube_link.youtube_link,
      "about_yourself": payload.about_yourself.about_yourself,
    };
  }

  function checkVowel(character) {
    let vowelRegex = /[aeiou]/i;

    return vowelRegex.test(character.toLowerCase().charAt(0));
  }

  function formatZipNumber(value) {
    const numericRegex = /^\d{0,5}$/
    if (numericRegex.test(value)) {
      inputChangeHandler("zip", value);
    }
  }

  function getInvitationFormats(url) {
    try {
      const parsedUrl = new URL(url);
      let invitation;

      if (parsedUrl.searchParams.has('invitation')) {
        invitation = parsedUrl.searchParams.get('invitation');
      } else {
        const pathSegments = parsedUrl.pathname.split('/');
        invitation = pathSegments[pathSegments.length - 1];
      }

      const dashed = invitation.replace(/-/g, '_');
      const plain = invitation.replace(/-/g, '');

      return { dashed, plain };
    } catch (error) {
      console.error('Invalid URL:', error);
      return { dashed: '', plain: '' };
    }
  }

  // console.log("namee",getInvitationFormats(window.location.href));


  function slide2Handler() {
    let temp_payload = { ...payload };

    if (validateInput(temp_payload, "input", "first_name", 1) &&
      validateInput(temp_payload, "input", "last_name", 1) &&
      validateInput(temp_payload, "input", "phone", 14) &&
      validateInput(temp_payload, "email", "email") &&
      validateInput(temp_payload, "input", "company") &&
      // validateInput(temp_payload, "input", "preferred_mailing_address") &&
      // validateInput(temp_payload, "input", "preferred_mailing_state") &&
      // validateInput(temp_payload, "input", "preferred_mailing_city") &&
      // validateInput(temp_payload, "input", "preferred_mailing_zip") &&
      validateInput(temp_payload, "checkbox", "tac")
    ) {

      setSubmitClicked(true);

      let submitUrl = "https://api.proinsight.com/submit_discovery_lead"

      if (window.location.href.includes("apply.proinsight.com")) {
        submitUrl = "https://api.proinsight.com/submit_apply_lead"
      }else if (window.location.href.includes("nbp.proinsight.com")) {
        submitUrl = "https://api.proinsight.com/submit_national_brand_lead"
      }

      let requestBody = {
        "first_name": payload.first_name.first_name,
        "last_name": payload.last_name.last_name,
        "phone": payload.phone.phone,
        "email": payload.email.email,
        "company": payload.company.company,
        ...((referred && redeemId) && { "redeemid": redeemId }),
        ...((window.location.href.includes("get.proinsight")) && {
          "preferred_mailing_address": {
            street_address: payload.preferred_mailing_address.preferred_mailing_address,
            state: payload.preferred_mailing_state.preferred_mailing_state,
            city: payload.preferred_mailing_city.preferred_mailing_city,
            zip: payload.preferred_mailing_zip.preferred_mailing_zip,
          }
        }),
      }

      fetch(submitUrl, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify(requestBody)
      })
        .then(resp => resp.json())
        .then(resp => {
          // console.log("respppp", resp);

          setSubmitClicked(false);
          // let test = "test"
          if (resp.message.includes("Phone")) {
            temp_payload = { ...temp_payload, "phone": { ...temp_payload["phone"], "warning": true, "text": resp } }
            setPayload({ ...temp_payload });
          }
          else if (resp.message.includes("Email")) {
            temp_payload = { ...temp_payload, "email": { ...temp_payload["email"], "warning": true, "text": resp } }
            setPayload({ ...temp_payload });
          } else if (resp === "Submited") {
            setSlideCount(slideCount + 1);
          }
          else if (resp.message === "Submited" || resp.message === "Submitted") {
            if (resp.contact_id) {
              setSubmittedContactId(resp.contact_id)
            }
            if (resp.contact_id && !window.location.href.includes("apply.proinsight.com") && !window.location.href.includes("pay.proinsight.com")) {
              console.log("inside the payment page")
              let redirectUrl = "https://proinsight.info/membershipsales"
              if(window.location.href.includes("nbp.proinsight.com")){
                redirectUrl = "https://proinsight.info/nationalbrandpartners-sales"
              }
              localStorage.setItem("ghlContactId", resp.contact_id);
              let fullName = `${payload.first_name.first_name} ${payload.last_name.last_name}`
              window.location.href = `${redirectUrl}?full_name=${fullName}&email=${payload.email.email}&phone=${payload.phone.phone}&redeemId=${redeemId || ""}`
            } else {
              console.log("else....")
              setSlideCount(slideCount + 1)
            }
            // setSlideCount(slideCount + 1);
          }
          else {
            alert("Something went wrong while submitting the data!");
            console.log(resp);
          }
        })
        .catch(err => {
          setSubmitClicked(false);
          alert("Something went wrong while submitting the data!");
          console.log(err);
        })
    }
    setPayload({ ...temp_payload });
  }
  // console.log("payload", payload);

  function slide3Handler() {
    let temp_payload = { ...payload };

    if (isValidContactId) {
      if (
        validateInput(temp_payload, "select", "profession")) {
        setSlideCount(5);
        setIsValidContactId(false)
        setIsAgreementContactId(true)
      }
    } else {

      if (
        validateInput(temp_payload, "select", "profession") &&
        validateInput(temp_payload, "checkbox", "are_you_forming_a_new_concierge_community") &&
        validateInput(temp_payload, "select", "state") &&
        validateInput(temp_payload, "select", "county") &&
        validateInput(temp_payload, "input", "city", 1) &&
        validateInput(temp_payload, "input", "zip", 5) &&
        validateInput(temp_payload, "checkbox", "checkoutTac")) {

        setSubmitClicked(true);

        let submitUrl = "https://api.proinsight.com/submit_discovery_lead"
        if (window.location.href.includes("apply.proinsight.com")) {
          submitUrl = "https://api.proinsight.com/submit_apply_lead"
        }else if (window.location.href.includes("nbp.proinsight.com")) {
          submitUrl = "https://api.proinsight.com/submit_national_brand_lead"
        }

        fetch(submitUrl, {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token
          },
          body: JSON.stringify({
            "first_name": payload.first_name.first_name,
            "last_name": payload.last_name.last_name,
            "phone": payload.phone.phone,
            "email": payload.email.email,
            "company": payload.company.company,
            "profession": payload.profession.profession,
            ...(!window.location.href.includes("nbp.proinsight.com") && {
              "are_you_forming_a_new_concierge_community": payload.are_you_forming_a_new_concierge_community.are_you_forming_a_new_concierge_community,
              "state": payload.state.state,
              "county": payload.county.county,
              "city": payload.city.city,
              "zip": payload.zip.zip,
            }),
            ...((referred && redeemId) && { "redeemid": redeemId }),
            ...((window.location.href.includes("get.proinsight")) && {
              "preferred_mailing_address": {
                street_address: payload.preferred_mailing_address.preferred_mailing_address,
                state: payload.preferred_mailing_state.preferred_mailing_state,
                city: payload.preferred_mailing_city.preferred_mailing_city,
                zip: payload.preferred_mailing_zip.preferred_mailing_zip,
              }
            }),
          })
        })
          .then(resp => {
            if (window.location.href.includes("nbp.proinsight.com")) {
              setSubmitClicked(false);
              setSlideCount(slideCount + 1);
            } else if (resp.ok) {
              // setSubmitClicked(false);
              // setSlideCount(slideCount+1);
              fetch("https://api.proinsight.com/zipAvailability", {
                method: "POST",
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': token
                },
                body: JSON.stringify({
                  "state": payload.state.state,
                  "county": payload.county.county,
                  "zip": payload.zip.zip,
                  "profession": payload.profession.profession,
                  "city": payload.city.city,
                  "contact_id": submittedContactId
                })
              })
                .then(resp => resp.json())
                .then(data => {
                  if (data === "Available") {
                    setSubmitClicked(false);
                    setSlideCount(slideCount + 1);
                  }
                  else {
                    setSubmitClicked(false);
                    toast.error(data);
                  }
                })
                .catch(err => {
                  setSubmitClicked(false);
                  toast.error("Something went wrong while submitting the data!");
                  console.log(err);
                });
            }
            else {
              setSubmitClicked(false);
              alert("Something went wrong! Try After Some time");
            }
          })
          .catch(err => {
            setSubmitClicked(false);
            alert("Something went wrong while submitting the data!");
            console.log(err);
          });
      }
    }
    setPayload({ ...temp_payload });
  }

  function slide4Handler() {
    let temp_payload = { ...payload };

    if (validateInput(temp_payload, "number", "clients_twelve_months") &&
      // validateInput(temp_payload, "select", "future_growth") &&
      validateInput(temp_payload, "number", "clients_warm_market") &&
      validateInput(temp_payload, "input", "from_which_profession_receive_most_referrals") &&
      validateInput(temp_payload, "input", "to_which_profession_send_most_referrals")
    ) {

      setSubmitClicked(true);

      let submitUrl = "https://api.proinsight.com/submit_discovery_lead"
      if (window.location.href.includes("apply.proinsight.com")) {
        submitUrl = "https://api.proinsight.com/submit_apply_lead"
      } else if (window.location.href.includes("nbp.proinsight.com")) {
        submitUrl = "https://api.proinsight.com/submit_national_brand_lead"
      }

      let requestBody = {
        "first_name": payload.first_name.first_name,
        "last_name": payload.last_name.last_name,
        "phone": payload.phone.phone,
        "email": payload.email.email,
        "company": payload.company.company,
        "profession": payload.profession.profession,
        ...(!window.location.href.includes("nbp.proinsight.com") && {
          "are_you_forming_a_new_concierge_community": payload.are_you_forming_a_new_concierge_community.are_you_forming_a_new_concierge_community,
          "state": payload.state.state,
          "county": payload.county.county,
          "city": payload.city.city,
          "zip": payload.zip.zip,
        }),
        "clients_twelve_months": payload.clients_twelve_months.clients_twelve_months,
        // "future_growth": payload.future_growth.future_growth,
        ...((referred && redeemId) && { "redeemid": redeemId }),
        ...((window.location.href.includes("get.proinsight")) && {
          "preferred_mailing_address": {
            street_address: payload.preferred_mailing_address.preferred_mailing_address,
            state: payload.preferred_mailing_state.preferred_mailing_state,
            city: payload.preferred_mailing_city.preferred_mailing_city,
            zip: payload.preferred_mailing_zip.preferred_mailing_zip,
          }
        }),
      }

      if (window.location.href.includes("apply.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) {
        requestBody.clients_warm_market = payload.clients_warm_market.clients_warm_market
        requestBody.from_which_profession_receive_most_referrals = payload.from_which_profession_receive_most_referrals.from_which_profession_receive_most_referrals
        requestBody.to_which_profession_send_most_referrals = payload.to_which_profession_send_most_referrals.to_which_profession_send_most_referrals
      }

      if (showProfileQuestions) {
        Object.assign(requestBody, getProfileAnswers())
      }

      fetch(submitUrl, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify(requestBody)
      })
        .then(resp => {
          if (window.location.href.includes("apply.proinsight.com")) {
            setSlideCount(14)
          } else {
            if (resp.ok) {
              const requestBody = {
                "state": payload.state.state,
                "county": payload.county.county,
                "zip": payload.zip.zip,
                "city": payload.city.city,
                "profession": payload.profession.profession,
                "clients_twelve_months": payload.clients_twelve_months.clients_twelve_months,
                // "future_growth": payload.future_growth.future_growth
              };
              // console.log("resp,resp", resp)

              if (window.location.href.includes("get.proinsight.com") || window.location.href.includes("nbp.proinsight.com") || window.location.href.includes("financing.proinsight.com")) {
                requestBody.contact_id = submittedContactId
              }

              if (!window.location.href.includes("pay.proinsight.com") && !window.location.href.includes("get.proinsight.com") && !window.location.href.includes("nbp.proinsight.com")) {

                fetch("https://api.proinsight.com/professionavailable", {
                  method: "POST",
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                  },
                  body: JSON.stringify(requestBody)
                })
                  .then(resp => resp.json())
                  .then(data => {
                    let invitationName = getInvitationFormats(window.location.href)
                    if (data === "Not Qualified") {
                      setSubmitClicked(false);
                      // setSlideCount(6);
                      // window.open(`https://proinsight.info/growthteamsales?full_name=${payload.first_name.first_name+" "+payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}`, "_self");

                      //not redirecting to the deepdive page
                      // if (payload.profession.profession === "Real Estate Agent" || payload.profession.profession === "Residential Lender") {
                      //   setUrlToRedirect({ [data]: `https://proinsight.info/deepdive-registration?full_name=${payload.first_name.first_name + " " + payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}&am_id=${invitationName.plain}` });
                      // } else {
                      //   setUrlToRedirect({ [data]: `https://proinsight.info/deepdive-registration?full_name=${payload.first_name.first_name + " " + payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}&am_id=${invitationName.plain}` });
                      // }
                      setSlideCount(15);
                    }
                    else {
                      setSubmitClicked(false);
                      if (data === "Qualified") {
                        let redirectionUrl = "https://proinsight.info/membershipsales"
                        if (window.location.href.includes("financing.proinsight.com")) {
                          redirectionUrl = "https://proinsight.info/membership-sales-page-financing-plan"
                        }
                        if (payload.profession.profession === "Real Estate Agent" || payload.profession.profession === "Residential Lender") {
                          setUrlToRedirect({ [data]: `${redirectionUrl}?full_name=${payload.first_name.first_name + " " + payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}&am_id=${invitationName.dashed}` });
                        } else {
                          setUrlToRedirect({ [data]: `${redirectionUrl}?full_name=${payload.first_name.first_name + " " + payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}&am_id=${invitationName.dashed}` });
                        }
                      } else {
                        setUrlToRedirect({ [data]: `https://proinsight.info/thankyoumember?first_name=${payload.first_name.first_name}&last_name=${payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}` });
                      }
                      setSlideCount(slideCount + 1);
                    }
                    // if(data === "Not Qualified"){
                    //   setSubmitClicked(false);
                    //   setSlideCount(6);
                    //   window.open(`https://proinsight.info/growthteamsales?full_name=${payload.first_name.first_name+" "+payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}`, "_self");
                    // }
                    // else{
                    //   setSubmitClicked(false);
                    //   if(data === "Qualified"){
                    //     if(payload.category.category === "Asset") setUrlToRedirect({"Asset" : `https://proinsight.info/membershipsales-asset-professionals?full_name=${payload.first_name.first_name+" "+payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}`});
                    //     else setUrlToRedirect({"Home Service" : `https://proinsight.info/membershipsales-home-service-professionals?full_name=${payload.first_name.first_name+" "+payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}`});
                    //   }
                    //   else setUrlToRedirect({[data] : `https://proinsight.info/thankyoumember?first_name=${payload.first_name.first_name}&last_name=${payload.last_name.last_name}&email=${payload.email.email}&phone=${payload.phone.phone}`});
                    //   setSlideCount(slideCount+1);
                    // }
                  })
                  .catch(err => {
                    setSubmitClicked(false);
                    alert("Something went wrong while validating profession");
                    console.log(err);
                  });
              } else if (window.location.href.includes("pay.proinsight.com") || window.location.href.includes("get.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) {
                setSubmitClicked(false);
                setSlideCount(slideCount + 1);
              }

            }
            else {
              setSubmitClicked(false);
              alert("Something went wrong! Try After Some time");
            }
          }
        })
        .catch(err => {
          setSubmitClicked(false);
          alert("Something went wrong while submitting the data!");
          console.log(err);
        });
    }
    setPayload({ ...temp_payload });
  }

  function submit() {
    if (readyToSubmit) {
      setSubmitClicked(true);
      fetch("https://api.proinsight.com/publicKey", {
        method: "POST",
        headers: { "Authorization": token }
      })
        .then(resp => resp.json())
        .then(async key => {
          if (key.public_key) {
            let firstObj = {
              "first_name": payload.first_name.first_name,
              "last_name": payload.last_name.last_name,
              "phone": payload.phone.phone,
              "email": payload.email.email,
              "company": payload.company.company,
              "profession": payload.profession.profession,
              "clients_twelve_months": payload.clients_twelve_months.clients_twelve_months,
              ...(!window.location.href.includes("nbp.proinsight.com") && {
                "are_you_forming_a_new_concierge_community": payload.are_you_forming_a_new_concierge_community.are_you_forming_a_new_concierge_community,
                "state": payload.state.state,
                "county": payload.county.county,
                "city": payload.city.city,
                "zip": payload.zip.zip,
              }),
              // "future_growth": payload.future_growth.future_growth,
              ...((referred && redeemId) && { "redeemid": redeemId }),
              ...((window.location.href.includes("get.proinsight")) && {
                "preferred_mailing_address": {
                  street_address: payload.preferred_mailing_address.preferred_mailing_address,
                  state: payload.preferred_mailing_state.preferred_mailing_state,
                  city: payload.preferred_mailing_city.preferred_mailing_city,
                  zip: payload.preferred_mailing_zip.preferred_mailing_zip,
                }
              }),
              ...(showProfileQuestions && getProfileAnswers()),
            }

            let password_data = await encryptPasswordWithKey(key.public_key, payload.password.password);
            let crm_password = await encryptPasswordWithKey(key.public_key_local, payload.password.password);

            let submitUrl = "https://api.proinsight.com/submit_discovery_lead"
            if (window.location.href.includes("nbp.proinsight.com")) {
              submitUrl = "https://api.proinsight.com/submit_national_brand_lead"
            }
            fetch(submitUrl, {
              method: "POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
              },
              body: JSON.stringify({ ...firstObj, ...password_data, crm_password })
            })
              .then(resp => {
                console.log("respmmmmm", resp);
                if (resp.ok) {
                  if (window.location.href.includes("pay.proinsight.com") || window.location.href.includes("get.proinsight.com") ) {
                    ////////////////////////////////////
                    fetch("https://api.proinsight.com/paid_professionavailable", {
                      method: "POST",
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': token
                      },
                      body: JSON.stringify({ ...firstObj, ...password_data, crm_password, contact_id: submittedContactId })
                    })
                      .then(resp => {
                        if (resp.ok) {
                          setSubmitClicked(false);
                          // setSlideCount(14);
                          window.top.location.href = `https://proinsight.info/welcome-call?first_name=${payload.first_name.first_name}&last_name=${payload.last_name.last_name}&phone=${payload.phone.phone}&email=${payload.email.email}&id=${redeemId || ""}`
                        }
                        else {
                          setSubmitClicked(false);
                          // alert("Something went wrong data not uploaded");
                          window.top.location.href = "https://proinsight.info/error"
                        }
                      })
                      .catch(err => {
                        setSubmitClicked(false);
                        // alert("Somthing went wrong while validating data")
                        window.top.location.href = "https://proinsight.info/error"
                        console.log(err);
                      })
                    //////////////////
                  }else if(window.location.href.includes("nbp.proinsight.com")){
                    resp.json().then(data => {
                      fetch("https://api.proinsight.com/trigger_create_nbp", {
                        method: "POST",
                        headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'Authorization': token
                        },
                        body: JSON.stringify({ contact_id: data.contact_id })
                      })
                        .then((resp) => {
                          if (resp.ok) {
                            setSubmitClicked(false);
                            setSlideCount(slideCount + 1);
                          }else{
                            setSubmitClicked(false);
                            // alert("Something went wrong data not uploaded");
                            window.top.location.href = "https://proinsight.info/error"
                          }
                        })
                        .catch(err => {
                          setSubmitClicked(false);
                          window.top.location.href = "https://proinsight.info/error"
                          console.log(err);
                        })
                    })
                  } else {
                    setSlideCount(slideCount + 1);
                    // window.open(urlToRedirect["Qualified"] || urlToRedirect["Not Qualified"] || urlToRedirect["Prospect"], "_self");
                    window.top.location.href = urlToRedirect["Qualified"] || urlToRedirect["Not Qualified"] || urlToRedirect["Prospect"];
                    // window.open(urlToRedirect["Asset"] || urlToRedirect["Home Service"] || urlToRedirect["Prospect"], "_self");
                  }
                }
                else {
                  setSubmitClicked(false);
                  alert("Something went wrong data not uploaded");
                }
              })
              .catch(err => {
                setSubmitClicked(false);
                alert("Somthing went wrong while validating data")
                console.log(err);
              })
          }
          else {
            setSubmitClicked(false);
          }
        })
        .catch(err => {
          console.log(err);
          setSubmitClicked(false);
          alert("Something Went Wrong! try After Some time ")
        })
    }
  }

  function submitByContactId() {
    if (readyToSubmit) {
      setSubmitClicked(true);
      fetch("https://api.proinsight.com/publicKey", {
        method: "POST",
        headers: { "Authorization": token }
      })
        .then(resp => resp.json())
        .then(async key => {
          if (key.public_key) {
            // let firstObj = {
            //   "first_name" : payload.first_name.first_name,
            //   "last_name" : payload.last_name.last_name,
            //   "phone": payload.phone.phone,
            //   "email": payload.email.email,
            //   "company": payload.company.company,
            //   "profession": payload.profession.profession,
            //   "clients_twelve_months": payload.clients_twelve_months.clients_twelve_months,
            //   "state": payload.state.state,
            //   "county": payload.county.county,
            //   "city" : payload.city.city,
            //   "zip": payload.zip.zip,
            //   "future_growth": payload.future_growth.future_growth,
            //   ...((referred && redeemId) && {"redeemid": redeemId}),
            // }
            let password_data = await encryptPasswordWithKey(key.public_key, payload.password.password);
            let crm_password = await encryptPasswordWithKey(key.public_key_local, payload.password.password);

            fetch("https://api.proinsight.com/submit_deepdive_password", {
              method: "POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
              },
              body: JSON.stringify({ contactId: contactId, ...password_data, crm_password })
            }).then(response => response.json())
              .then(resp => {
                console.log("resp", resp)
                let fullName = resp.first_name + " " + (resp.last_name || "")
                let invitationName = getInvitationFormats(window.location.href)
                if (resp.affliate_id) {
                  if (payload.profession.profession === "Real Estate Agent" || payload.profession.profession === "Residential Lender") {
                    // window.open(`https://proinsight.info/deepdive-registration?full_name=${fullName}&email=${resp.email}&phone=${resp.phone}&am_id=${resp.affliate_id}`, "_self");
                    window.top.location.href = `https://proinsight.info/deepdive-registration?full_name=${fullName}&email=${resp.email}&phone=${resp.phone}&am_id=${resp.affliate_id}`;
                  } else {
                    window.top.location.href = `https://proinsight.info/deepdive-registration?full_name=${fullName}&email=${resp.email}&phone=${resp.phone}&am_id=${resp.affliate_id}`;
                  }
                } else if (resp.email) {
                  // setSlideCount(slideCount+1);
                  if (payload.profession.profession === "Real Estate Agent" || payload.profession.profession === "Residential Lender") {
                    window.top.location.href = `https://proinsight.info/deepdive-registration?full_name=${fullName}&email=${resp.email}&phone=${resp.phone}&am_id=${invitationName.plain}`;
                  } else {
                    window.top.location.href = `https://proinsight.info/deepdive-registration?full_name=${fullName}&email=${resp.email}&phone=${resp.phone}&am_id=${invitationName.plain}`;
                  }
                  // window.open(urlToRedirect["Asset"] || urlToRedirect["Home Service"] || urlToRedirect["Prospect"], "_self");
                }
                else {
                  setSubmitClicked(false);
                  alert("Something went wrong data not uploaded");
                }
              })
              .catch(err => {
                setSubmitClicked(false);
                alert("Somthing went wrong while validating data")
                console.log(err);
              })
          }
          else {
            setSubmitClicked(false);
          }
        })
        .catch(err => {
          console.log(err);
          setSubmitClicked(false);
          alert("Something Went Wrong! try After Some time ")
        })
    }
  }

  return (
    <>
      <PageIndicator currentPage={slideCount - 1} steps={5} />

      <div className="left-container">
        {
          (windowWidth > 1024 || slideCount > 1)
          &&
          <img style={{ display: slideCount === 1 ? "block" : "none" }} src={(referred && referredImg) ? referredImg : "https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/670fb881282d80545828706c.png"} alt="left-img" />
        }

        {(slideCount === 2 && (window.location.href.includes("get.proinsight.com") || window.location.href.includes("nbp.proinsight.com"))) ? <img style={{ display: slideCount === 2 ? "block" : "none" }} src={(referred && referredImg) ? referredImg : "https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/670fb881282d80545828706c.png"} alt="left-img" />
          : <video style={{ display: slideCount === 2 ? "block" : "none" }} autoPlay loop muted playsInline>
            <source src='https://assets.cdn.filesafe.space/sIF5ZS1VxhUZsYbvq7gL/media/69ca9b0192908d26666f7064.mp4' />
          </video>}

        <img style={{ display: (slideCount === 3 || isValidContactId) ? "block" : "none" }} src="https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/6658c8a3ce5dc9e5e410ef3d.jpeg" alt="left-img" />

        <img style={{ display: slideCount === 4 ? "block" : "none" }} src="https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/6658cf9360d3a7466844b625.jpeg" alt="left-img" />

        <img style={{ display: slideCount === 5 ? "block" : "none" }} src="https://assets.cdn.filesafe.space/sIF5ZS1VxhUZsYbvq7gL/media/69ca9830eab9f1b484c32de7.webp" alt="left-img" />
      </div>

      <div className="right-container" ref={right_container}>
        <div style={{ display: slideCount === 1 ? "block" : "none" }} className="slide slide1">
          <div>
            <h3>
              Learn how ProInsight™ can help you serve at least two more "ideal clients" every single month via introductions from professionals.
            </h3>

            <div className='iframe-container'>
              <iframe src="https://player.vimeo.com/video/1016359640?h=4a43469fc9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="ProInsight 3-Minute Intro">
              </iframe>
            </div>
            <ButtonwithEnter indexId="1" text="Apply for membership" onClickFn={() => setSlideCount(slideCount + 1)} />
          </div>
        </div>

        <div style={{ display: slideCount === 2 ? "block" : "none", paddingTop: (window.location.href.includes("get.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) && "5%" }} className="slide slide2">
          {window.location.href.includes("get.proinsight.com") && !window.location.href.includes("nbp.proinsight.com") && <h3 style={{ fontSize: "26px", paddingBottom: "1rem", fontWeight: "600" }} >Join my Homeowner Concierge™ Community</h3>}
          <form className="contact-info-form">
            <Title pagenum="1" title="Let's start by ensuring we have your correct contact information *" />
            <div>
              <label htmlFor="f-name">First Name *</label>
              <input id='f-name'
                value={payload.first_name.first_name}
                onChange={(e) => { inputChangeHandler("first_name", e.target.value) }}
                type="text" placeholder='Jane'
                required />
              <Warning display={payload.first_name.warning} />
            </div>

            <div>
              <label htmlFor="l-name">Last Name *</label>
              <input
                id='l-name'
                type="text"
                value={payload.last_name.last_name}
                onChange={(e) => inputChangeHandler("last_name", e.target.value)}
                placeholder='Smith'
                required />
              <Warning display={payload.last_name.warning} />
            </div>

            <div>
              <label htmlFor="phone">Phone *</label>
              <input
                id='phone'
                type="tel"
                value={payload.phone.phone}
                onChange={(e) => { inputChangeHandler("phone", formatPhoneNumber(e.target.value)) }}
                placeholder='(201) 555-0123'
                required />
              <Warning display={payload.phone.warning} text={payload.phone.text} />
            </div>

            <div>
              <label htmlFor="email">Email *</label>
              <input
                id='email'
                type="email"
                value={payload.email.email}
                onChange={(e) => { inputChangeHandler("email", e.target.value) }}
                placeholder='name@example.com'
                required />
              <Warning display={payload.email.warning} text={payload.email.text} />
            </div>

            <div>
              <label htmlFor="company">Company *</label>
              <input
                id='company'
                type="text"
                value={payload.company.company}
                onChange={(e) => { inputChangeHandler("company", e.target.value) }}
                placeholder='Acme Corporation' />
              <Warning display={payload.company.warning} />
            </div>

             {window.location.href.includes("get.proinsight") && <div>
              <label htmlFor="preferred_mailing_address">Preferred Mailing Address </label>
              <input
                id='preferred_mailing_address'
                type="text"
                value={payload.preferred_mailing_address.preferred_mailing_address}
                onChange={(e) => { inputChangeHandler("preferred_mailing_address", e.target.value) }}
                placeholder='123 Main Street, Apt 4B' />
              <Warning display={payload.preferred_mailing_address.warning} />
              <div style={{ marginTop: "2rem" }} >
                <div className='stateCityContainer' style={{ display: "flex", width: "100%", gap: "1rem" }} >
                  <div>
                    <input
                      id="preferred_mailing_city"
                      type="text"
                      value={payload.preferred_mailing_city.preferred_mailing_city}
                      onChange={(e) => { inputChangeHandler("preferred_mailing_city", e.target.value) }}
                      placeholder='City' />
                    <Warning display={payload.preferred_mailing_city.warning} />
                  </div>

                  <div >
                    <select style={{ height: "57px", color: payload.preferred_mailing_state.preferred_mailing_state === "none" && "#949CAB" }}
                      id="preferred_mailing_state"
                      value={payload.preferred_mailing_state.preferred_mailing_state}
                      onChange={(e) => {
                        inputChangeHandler("preferred_mailing_state", e.target.value)
                      }}>
                      <option style={{ color: "grey" }} value="none">State</option>
                      {
                        (states && states.length > 0)
                        &&
                        states.map((preferred_mailing_state, idx) => (
                          Object.keys(preferred_mailing_state).map((key) => (
                            <option value={preferred_mailing_state[key]} key={idx}>{key}</option>
                          ))
                        ))
                      }
                    </select>
                    <Warning display={payload.preferred_mailing_state.warning} />
                  </div>

                </div>
                <div style={{ marginTop: "2rem" }} >
                  <input
                    id="preferred_mailing_zip"
                    type="text"
                    value={payload.preferred_mailing_zip.preferred_mailing_zip}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '');
                      if (val.length <= 5) {
                        inputChangeHandler("preferred_mailing_zip", val);
                      }
                    }}
                    onInput={(e) => {
                      // This helps catch autofill better in some browsers
                      if (e.nativeEvent.inputType === 'insertFromPaste' ||
                        e.nativeEvent.inputType === 'insertReplacementText') {
                        const val = e.target.value.replace(/\D/g, '');
                        if (val.length <= 5) {
                          inputChangeHandler("preferred_mailing_zip", val);
                        }
                      }
                    }}
                    placeholder="Zip"
                    maxLength={5}
                    autoComplete="postal-code"
                  />
                  <Warning display={payload.preferred_mailing_zip.warning} />
                </div>
              </div>
              <span style={{ fontSize: "15px", marginTop: "1rem" }} >We have a gift we’d love to send you</span>
            </div>

            } 

            <div style={{ display: "flex", flexDirection: "row", alignItems: "start" }}>
              <input
                id='tac'
                style={{ margin: "1rem 1rem 0 0" }}
                checked={payload.tac.tac}
                onChange={(e) => { inputChangeHandler("tac", e.target.checked) }}
                type="checkbox" />
                <div>
                <label htmlFor='tac'>I agree to ProInsight’s <a href="https://proinsight.com/termsconditions/" rel='noreferrer' target='_blank'>terms & conditions</a>. By providing my phone number, I consent to receive text messages from ProInsight.</label>
                <Warning display={payload.tac.warning} />
              </div>
            </div>
          </form>
          <ButtonwithEnter state={slideCount} setState={setSlideCount} indexId="2" text="NEXT" onClickFn={slide2Handler} submitState={submitClicked} />
        </div>

        <div style={{ display: (slideCount === 3 || isValidContactId) ? "block" : "none" }} className="slide slide3">
          {/* <div className="group1">
            <Title pagenum={isValidContactId ? "1" : "2"} title="What is your Business Category? *" />
            <div className="business-category">
              <select
                id="business-category-dropdown"
                value={payload.category.category}
                onChange={(e) => { inputChangeHandler("category", e.target.value) }}>
                <option value="none" >Select</option>
                {
                  categories
                  &&
                  categories.map((category, idx) => (
                    <option value={category} key={idx}>{category}</option>
                  ))
                }
              </select>
              <Warning display={payload.category.warning} />
            </div>
          </div> */}

          {/* <div className="group2">
            <Title pagenum={isValidContactId ? "2" : "3"} title="What is your Primary Business? *" />
            <div className="primary-business">
              <select
                id="business-type-dropdown"
                value={payload.profession.profession}
                onChange={(e) => { inputChangeHandler("profession", e.target.value) }}>
                <option value="none" >Select</option>
                {
                  professions
                  &&
                  professions.map((profession, idx) => (
                    <option value={profession} key={idx}>{profession}</option>
                  ))
                }
              </select>
              <Warning display={payload.profession.warning} />
            </div>
          </div> */}

          <div className="group2">
            <Title
              pagenum={isValidContactId ? "2" : "3"}
              title="What is your Primary Business? *"
            />

            <div className="primary-business">
              <select
                id="business-type-dropdown"
                value={payload.profession.profession}
                onChange={(e) => inputChangeHandler("profession", e.target.value)}
              >
                <option value="none">Select</option>

                {Object.keys(professions)?.map((category) => (
                  <optgroup key={category} label={category} style={{ color: "black" }}>
                    {professions[category]?.map((item, idx) => (
                      <option value={item} key={`${category}-${idx}`}>
                        {item}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </select>

              <Warning display={payload.profession.warning} />
            </div>
          </div>

          {!window.location.href.includes("nbp.proinsight.com") && <div >
            {/* <label htmlFor="f-name">Are you forming a new Concierge Community or joining an existing one? </label> */}
            <Title pagenum="4" title="Are you forming a new Concierge Community or joining an existing one? *" />
            <div className="using-for" style={{ marginTop: "-10px" }} >
              <div className='radio-label-container' style={{ alignItems: "start" }} >
                <input
                  style={{ height: "16px", width: "16px", marginTop: "10px" }}
                  type="checkbox"
                  id='yes'
                  value="Yes"
                  checked={payload.are_you_forming_a_new_concierge_community.are_you_forming_a_new_concierge_community === 'Yes'}
                  onChange={(e) => { inputChangeHandler("are_you_forming_a_new_concierge_community", e.target.value) }} />
                <label htmlFor='yes' style={{ fontSize: "18px" }} >I want to start a new Concierge Community</label>
              </div>
              <div className='radio-label-container' style={{ alignItems: "start" }}>
                <input
                  style={{ height: "16px", width: "16px", marginTop: "10px" }}
                  type="checkbox"
                  id='no'
                  value="No"
                  checked={payload.are_you_forming_a_new_concierge_community.are_you_forming_a_new_concierge_community === 'No'}
                  onChange={(e) => { inputChangeHandler("are_you_forming_a_new_concierge_community", e.target.value) }} />
                <label htmlFor='no' style={{ fontSize: "18px" }} >I want to join an existing Concierge Community</label>
              </div>

              <Warning display={payload.are_you_forming_a_new_concierge_community.warning} />
            </div>
          </div>}

          <div style={{ display: isValidContactId ? "none" : "block" }} className="group2">
            <div>
              {!window.location.href.includes("nbp.proinsight.com") && <div>
                <Title pagenum="5" title="If approved, what county would you like to reserve as your territory? *" />
                <div className="territory">
                  <div>
                    <label htmlFor="state">State *</label>
                    <select
                      style={{ color: payload.state.state === "none" && "#949CAB" }}
                      id="state"
                      value={payload.state.state}
                      onChange={(e) => { inputChangeHandler("state", e.target.value) }}>
                      <option value="none">Select</option>
                      {
                        (states && states.length > 0)
                        &&
                        states.map((state, idx) => (
                          Object.keys(state).map((key) => (
                            <option value={state[key]} key={idx}>{key}</option>
                          ))
                        ))
                      }
                    </select>
                    <Warning display={payload.state.warning} />
                  </div>

                  <div>
                    <label htmlFor="county">County *</label>
                    <select
                      style={{ color: payload.county.county === "none" && "#949CAB" }}
                      id="county"
                      value={payload.county.county}
                      onChange={(e) => { inputChangeHandler("county", e.target.value) }}>
                      <option value="none">Select</option>
                      {
                        countys
                        &&
                        countys.map((county, idx) => (
                          <option value={county} key={idx}>{county}</option>
                        ))
                      }
                    </select>
                    <Warning display={payload.county.warning} />
                  </div>

                  <div>
                    <label htmlFor="city">City *</label>
                    <input
                      id="city"
                      type="text"
                      value={payload.city.city}
                      onChange={(e) => { inputChangeHandler("city", e.target.value) }}
                      placeholder='Albany' />
                    <Warning display={payload.city.warning} />
                  </div>

                  <div>
                    <label htmlFor="zip">Zip *</label>
                    {/* <input
                  id="zip"
                  type="text"
                  value={payload.zip.zip}
                  onChange={(e) => { formatZipNumber(e.target.value) }}
                  placeholder='94304' /> */}
                    <input
                      id="zip"
                      type="text"
                      value={payload.zip.zip}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, '');
                        if (val.length <= 5) {
                          inputChangeHandler("zip", val);
                        }
                      }}
                      onInput={(e) => {
                        // This helps catch autofill better in some browsers
                        if (e.nativeEvent.inputType === 'insertFromPaste' ||
                          e.nativeEvent.inputType === 'insertReplacementText') {
                          const val = e.target.value.replace(/\D/g, '');
                          if (val.length <= 5) {
                            inputChangeHandler("zip", val);
                          }
                        }
                      }}
                      placeholder="94304"
                      maxLength={5}
                      autoComplete="postal-code"
                    />
                    <Warning display={payload.zip.warning} />
                  </div>
                </div>
              </div>}

              {(window.location.href.includes("get.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) && <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "start" }}>
                  <input
                    id='checkoutTac'
                    style={{ margin: "1rem 1rem 0 0" }}
                    checked={payload.checkoutTac.checkoutTac}
                    onChange={(e) => { inputChangeHandler("checkoutTac", e.target.checked) }}
                    type="checkbox" />

                  <div htmlFor='checkoutTac'  >
                    <div style={{ fontSize: "16px" }}>
                      Prior to installing or publishing any Homeowner Concierge™ program content, including website language, marketing materials, vendor directories, or client-facing resources, I acknowledge that I am responsible for reviewing this program with my broker of record and/or independent legal counsel.
                    </div>
                    <div style={{ fontSize: "16px" }}>
                      I understand that Homeowner Concierge™ provides program frameworks and suggested language for general informational purposes only and does not provide legal advice.
                    </div>
                    <div style={{ fontSize: "16px" }}>
                      I accept full responsibility for ensuring that all Homeowner Concierge™ materials comply with my brokerage policies and all applicable local, state, and federal regulations.
                    </div>
                  </div>
                </div>
                <div style={{ marginLeft: "20px" }} >
                  <Warning display={payload.checkoutTac.warning} />
                </div>
              </div>}
            </div>
          </div>
          <ButtonwithEnter state={slideCount} setState={setSlideCount} indexId="3" text="NEXT" onClickFn={slide3Handler} submitState={submitClicked} />
        </div>

        <div style={{ display: slideCount === 4 ? "block" : "none" }} className={`slide slide4 ${(window.location.href.includes("apply.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) ? "applyUrlForm" : ""} ${showProfileQuestions ? "profileQuestionsForm" : ""}`} >
          <div className="group1">
            <Title pagenum={window.location.href.includes("nbp.proinsight.com") ? "4" : "6"} title={
              payload.profession.profession !== "none"
                ?
                checkVowel(payload.profession.profession)
                  ?
                  "As an " + payload.profession.profession + ", how many clients did you serve in the past twelve months? *"
                  : "As a " + payload.profession.profession + ", how many clients did you serve in the past twelve months? *"
                :
                "As a ___, how many clients did you serve in the past twelve months? *"} />
            <div className="number-of-clients">
              <label htmlFor="number-of-clients-input">CLIENTS</label>
              <input type="text" placeholder='0' value={payload.clients_twelve_months.clients_twelve_months} onChange={(e) => {
                let inputValue = e.target.value;

                if (inputValue === "" || /^[1-9]\d*$/.test(inputValue)) {
                  inputChangeHandler(
                    "clients_twelve_months",
                    inputValue === "" ? "" : Number(inputValue)
                  );
                }
              }} className="number-of-clients-input" />
              {
                // <div className="increment-decrement-button-container">
                //   <button className="decrement-button" onClick={(e)=>{
                //     if(payload.clients_twelve_months.clients_twelve_months > 1){
                //       inputChangeHandler("clients_twelve_months", payload.clients_twelve_months.clients_twelve_months - 1);
                //     }
                //   }}>-</button>
                //   <button className="increment-button" onClick={(e)=>inputChangeHandler("clients_twelve_months", payload.clients_twelve_months.clients_twelve_months + 1)}>+</button>
                // </div>
              }
              <Warning display={payload.clients_twelve_months.warning} />
            </div>
          </div>

          {/* <div className="group2">
            <Title pagenum="6" title="Concerning the FUTURE GROWTH of your business, do you want your growth to come by? *" />
            <div className="warm-market">
              <select
                id="warm-market-dropdown"
                value={payload.future_growth.future_growth}
                onChange={(e) => { inputChangeHandler("future_growth", e.target.value) }}>
                <option value="none">Select</option>
                <option value="Less than 50% by warm market referrals">Cold Market Leads</option>
                <option value="More than 50% by warm market referrals">Warm Market Referrals</option>
              </select>
              <Warning display={payload.future_growth.warning} />
            </div>
          </div> */}

          {(window.location.href.includes("apply.proinsight.com") || window.location.href.includes("nbp.proinsight.com")) && <div>
            <div style={{ marginBottom: "4rem" }} >
              <Title pagenum={window.location.href.includes("nbp.proinsight.com") ? "5" : "7"} title="Approximately how many people are in your database? (Not purchased leads but actual relationships) *" />
              <div className="warm-market">
                <input type="text" placeholder='0' value={payload.clients_warm_market.clients_warm_market} onChange={(e) => {
                  let inputValue = e.target.value;

                  if (inputValue === "" || /^[1-9]\d*$/.test(inputValue)) {
                    inputChangeHandler(
                      "clients_warm_market",
                      inputValue === "" ? "" : Number(inputValue)
                    );
                  }
                }} className="number-of-clients-input" />
                <Warning display={payload.clients_warm_market.warning} />
              </div>
            </div>

            <div style={{ marginBottom: "4rem" }} >
              <Title pagenum={window.location.href.includes("nbp.proinsight.com") ? "6" : "8"} title="From which profession do you receive the most amount of referrals? *" />
              <div className="warm-market">
                <input id='from_which_profession_receive_most_referrals'
                  value={payload.from_which_profession_receive_most_referrals.from_which_profession_receive_most_referrals}
                  onChange={(e) => { inputChangeHandler("from_which_profession_receive_most_referrals", e.target.value) }}
                  type="text" placeholder=''
                  required />
                <Warning display={payload.from_which_profession_receive_most_referrals.warning} />
              </div>
            </div>

            <div style={{ marginBottom: "4rem" }} >
              <Title pagenum={window.location.href.includes("nbp.proinsight.com") ? "7" : "9"} title="To which profession do you send the most amount of referrals? *" />
              <div className="warm-market">
                <input id='to_which_profession_send_most_referrals'
                  value={payload.to_which_profession_send_most_referrals.to_which_profession_send_most_referrals}
                  onChange={(e) => { inputChangeHandler("to_which_profession_send_most_referrals", e.target.value) }}
                  type="text" placeholder=''
                  required />
                <Warning display={payload.to_which_profession_send_most_referrals.warning} />
              </div>
            </div>

          </div>

          }

          {showProfileQuestions && <div className="contact-info-form profile-questions">
            <div>
              <label htmlFor="to_which_profession_send_most_referrals">Which Professionals do you refer the most?</label>
              <input
                id="to_which_profession_send_most_referrals"
                type="text"
                value={payload.to_which_profession_send_most_referrals.to_which_profession_send_most_referrals}
                onChange={(e) => { inputChangeHandler("to_which_profession_send_most_referrals", e.target.value) }} />
            </div>

            <div>
              <label htmlFor="from_which_profession_receive_most_referrals">Which Professionals refer you the most?</label>
              <input
                id="from_which_profession_receive_most_referrals"
                type="text"
                value={payload.from_which_profession_receive_most_referrals.from_which_profession_receive_most_referrals}
                onChange={(e) => { inputChangeHandler("from_which_profession_receive_most_referrals", e.target.value) }} />
            </div>

            <div>
              <label htmlFor="website_url">Company Website</label>
              <input
                id="website_url"
                type="url"
                value={payload.website_url.website_url}
                onChange={(e) => { inputChangeHandler("website_url", e.target.value) }}
                placeholder="Web URL goes here" />
            </div>

            <div>
              <label htmlFor="instagram_handle">Instagram Handle</label>
              <input
                id="instagram_handle"
                type="text"
                value={payload.instagram_handle.instagram_handle}
                onChange={(e) => { inputChangeHandler("instagram_handle", e.target.value) }} />
            </div>

            <div>
              <label htmlFor="facebook_link">Company Facebook link</label>
              <input
                id="facebook_link"
                type="url"
                value={payload.facebook_link.facebook_link}
                onChange={(e) => { inputChangeHandler("facebook_link", e.target.value) }} />
            </div>

            <div>
              <label htmlFor="linkedin_handle">Linkedin handle</label>
              <input
                id="linkedin_handle"
                type="text"
                value={payload.linkedin_handle.linkedin_handle}
                onChange={(e) => { inputChangeHandler("linkedin_handle", e.target.value) }} />
            </div>

            <div>
              <label htmlFor="tiktok_handle">Tiktok handle</label>
              <input
                id="tiktok_handle"
                type="text"
                value={payload.tiktok_handle.tiktok_handle}
                onChange={(e) => { inputChangeHandler("tiktok_handle", e.target.value) }} />
            </div>

            <div>
              <label htmlFor="youtube_link">YouTube link</label>
              <input
                id="youtube_link"
                type="url"
                value={payload.youtube_link.youtube_link}
                onChange={(e) => { inputChangeHandler("youtube_link", e.target.value) }} />
            </div>

            <div>
              <label htmlFor="about_yourself">Tell Us About Yourself: Share a short, confident summary that highlights your expertise, key strengths, and accomplishments. Help clients and the members referring them to you understand what sets you apart and why they can feel confident choosing to work with you.</label>
              {/* stopPropagation keeps Enter from reaching App's global Enter-to-advance handler */}
              <textarea
                id="about_yourself"
                rows={5}
                value={payload.about_yourself.about_yourself}
                onChange={(e) => { inputChangeHandler("about_yourself", e.target.value) }}
                onKeyDown={(e) => { e.stopPropagation() }} />
            </div>
          </div>}

          <ButtonwithEnter state={slideCount} setState={setSlideCount} indexId="4" text={window.location.href.includes("apply.proinsight.com") ? "SUBMIT" : "NEXT"} onClickFn={slide4Handler} submitState={submitClicked} />
        </div>

        {
          !showAgreement
          &&
          <div style={{ display: slideCount === 5 || isValidContactId ? "block" : "none" }} className="slide slide6">
            <Title pagenum="7" title="Create your ProInsight account" />
            <label htmlFor="password">Choose a robust password to secure your account</label>
            <div className="password">
              <div className='password-container'>
                <input
                  type={payload.password.type}
                  className='password-input'
                  value={payload.password.password}
                  onChange={(e) => { inputChangeHandler("password", e.target.value) }}
                  placeholder='Password' />
                {
                  passwordEye ? <Eye className='password-eye' onClick={passwordEyeHandler} /> : <Eyeoff className='password-eyeoff' onClick={passwordEyeHandler} />
                }
              </div>
              <div className='confirm-password-container'>
                <input
                  type={payload.confirm_password.type}
                  value={payload.confirm_password.confirm_password}
                  onChange={(e) => { inputChangeHandler("confirm_password", e.target.value) }}
                  placeholder='Confirm Password' />
                {
                  confirmPasswordEye ? <Eye className='confirm-password-eye' onClick={confirmPasswordEyeHandler} /> : <Eyeoff className='confirm-password-eyeoff' onClick={confirmPasswordEyeHandler} />
                }
              </div>

              <PasswordValidattor
                rules={['minLength',
                  'maxLength',
                  'specialChar',
                  'number',
                  'capital',
                  'matches',
                  'lowercase',
                  'notEmpty']}
                minLength={9}
                maxLength={64}
                password={payload.password.password}
                confirmedPassword={payload.confirm_password.confirm_password}
                iconSize={16}
                onValidatorChange={(res) => readyToSubmit = res}
                config={
                  {
                    customText: {
                      capital: {
                        successText: 'Contains capital letter',
                        errorText: 'Password should contain a capital letter'
                      },
                      lowercase: {
                        successText: 'Contains lowercase letter',
                        errorText: 'Please add at least one lowercase letter'
                      }
                    },
                    showProgressBar: true,
                    classNames: {
                      containerClass: 'my-container-custom-class',
                      gridClass: 'my-grid-custom-class',
                      ruleClass: 'my-rule-custom-class',
                      validProgressBarClass: 'my-valid-progress-bar-custom-class',
                      invalidProgressBarClass: 'my-invalid-progress-bar-custom-class'
                    }
                  }} />
            </div>
            <ButtonwithEnter indexId="5" text="SUBMIT" onClickFn={isAgreementContactId ? submitByContactId : submit} submitState={submitClicked} />
          </div>
        }
      </div>
    </>
  )
}